import useLocalStorageState from 'ahooks/es/useLocalStorageState';

import { ScheduleViewType } from '../types';

export const useScheduleViewType = () =>
  useLocalStorageState<ScheduleViewType>('schedule-view-type', {
    defaultValue: 'GANTT',
    listenStorageChange: true,
  });
